module.exports = __webpack_public_path__ + "img/u410.8132f061.svg";